import { Box, IconButton } from '@mui/material'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'

function CollapseCell({
    onAllCollapse,
    isAllCollapse,
    disabled = false,
}: {
    onAllCollapse: (val: boolean) => void
    isAllCollapse: boolean
    disabled?: boolean
}) {
    return (
        <Box textAlign={'center'}>
            <Box>
                <IconButton
                    sx={{
                        padding: 0,
                        margin: 0,
                        bottom: 0,
                    }}
                    onClick={() => onAllCollapse(false)} // it will Close
                    disabled={isAllCollapse || disabled}
                >
                    <KeyboardArrowUpIcon />
                </IconButton>
            </Box>
            <Box>
                <IconButton
                    sx={{
                        padding: 0,
                        margin: 0,
                        top: 0,
                    }}
                    onClick={() => onAllCollapse(true)} // it will open
                    disabled={!isAllCollapse || disabled}
                >
                    <KeyboardArrowDownIcon />
                </IconButton>
            </Box>
        </Box>
    )
}
export default CollapseCell
